<template>
    <div id="dashboard">
        <div class="ui inverted dimmer" :class="{'active': is_loading}">
            <div class="ui indeterminate text loader">
                <!-- 處理中... -->
                {{ $t('ui.general.initializing') }}
            </div>
        </div>

        <div class="ui form"
            :class="{
                'loading': is_processing,
                'inverted': is_inverted
            }">
            <div class="ui fluid right action left icon big input"
                :class="{'inverted transparent': is_inverted}"
                :style="{
                    borderBottom: '4px ' + current_setting_group.color + ' solid',
                    color: theme.color.font
                }">
                <i class="search icon"></i>

                <input class="no bottom border"
                    v-if="is_input_mode"
                    type="text"
                    ref="search_input"
                    id="search_input"
                    @blur="input_blurred()"
                    @keypress.enter="input_submit()"
                    autofocus="true"
                    autocomplete="off"
                    v-model="input_number"
                    :placeholder="$t('ui.scanner.helps.write_or_scan_barcode')"
                    :style="{
                        background: 'none',
                        color: theme.color.font
                    }"
                    >
                <div id="search_input" v-else @click.prevent="input_focused()">
                    {{ current_number || $t('ui.scanner.helps.write_or_scan_barcode') }}
                </div>
                <!-- <input class="no bottom border"
                    type="text"
                    id="search_input"
                    ref='search'
                    v-if="modals_active_scanner_boolean"
                    v-model="current_number"
                    @keypress.enter="submit"
                    @blur="focus_search_input"
                    autocomplete="off"
                    :disabled="settings.is_scan_mode"
                    placeholder="輸入號碼或是掃描條碼"> -->
                <div class="ui button no bottom border"
                    :class="{
                        'inverted': is_inverted,
                        'current_setting_group': current_setting_group,
                    }"
                    :style="{
                        backgroundColor: current_setting_group.color
                    }"
                    @click="toggle_settings()">
                    <i class="large icons" style="margin: 5px;color: white;">
                        <i :class="current_setting_group.primary_icon_classes"></i>
                        <i :class="current_setting_group.secondary_icon_classes || 'right bottom corner icon'"></i>
                    </i>
                    <!-- <i v-if="!current_setting_group"
                        class="big floating ellipsis vertical icon"
                        style="margin:0;">
                    </i>
                    <img v-else
                        class="sprite"
                        :src="'/images/barcode_setting_group_icons/'+current_setting_group.icon_file_name+'.svg'"> -->
                </div>

            </div>
            <div class="ui bottom right settings label no top border pointer"
                @click="toggle_settings()"
                :class="{
                    'inverted': is_inverted,
                    'show_setting_modes_content': is_setting
                }"
                :style="{
                    background: 'none',
                    color: theme.color.font
                }"
                >

                <div class="settings_content">
                    <span class="setting_modes_content"
                        :class="{'show_setting_modes_content':is_setting}"
                    >
                        <!--
                        --><span v-if="settings.is_scan_action_mode && current_scan_action_prototype.identity"><!--
                            -->{{ current_scan_action_prototype.name + '(' + current_scan_action_prototype.barcode + ')' }}、
                        </span>
                        <span v-else>
                            <span v-if="!current_setting_group.is_hide">
                                {{ current_setting_group.name }} 、
                            </span>
                        </span>

                        {{ settings.is_batch_mode ? $tc('ui.scanner.settings.is_batch_mode.true')+'、':'' }}
                        {{ settings.is_distributed_to_mode ? $tc('ui.scanner.settings.is_distributed_to_mode.true', 2)+'、':'' }}
                        {{ settings.is_package_mode ? $tc('ui.scanner.settings.is_package_mode.true', 2)+'、':'' }}
                        {{ settings.is_unpackage_mode ? $tc('ui.scanner.settings.is_unpackage_mode.true', 2)+'、':'' }}

                        <span v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_auto_print_label_mode')">
                            {{ settings.is_auto_print_label_mode
                                ? $tc('ui.scanner.settings.is_auto_print_label_mode.true', 2)
                                : $tc('ui.scanner.settings.is_auto_print_label_mode.false', 2)
                            }}、
                        </span>

                        <!-- {{ settings.is_high_performance_mode ? '高效能、': '' }} -->
                        <span v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_scan_mode')">
                            {{ settings.is_scan_mode
                                ? $tc('ui.scanner.settings.is_scan_mode.true', 2)
                                : $tc('ui.scanner.settings.is_scan_mode.false', 2)
                            }}、
                        </span>

                        <span v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_speech_mode')">
                            {{ settings.is_speech_mode
                                ? $tc('ui.scanner.settings.is_speech_mode.true', 2)
                                : $tc('ui.scanner.settings.is_speech_mode.false', 2)
                            }}、
                        </span>

                        {{ settings.is_update_core_waybill_mode ? $tc('ui.scanner.settings.is_update_core_waybill_mode.true', 2)+'、': '' }}

                        <!-- 檢視模式： -->
                        {{ $t('ui.scanner.settings.core_waybill_template_mode.short_name') }}：
                        {{ settings.core_waybill_template_mode == 'min_card' ? $tc('ui.scanner.settings.core_waybill_template_mode.min_card', 2) : '' }}
                        {{ settings.core_waybill_template_mode == 'card' ? $tc('ui.scanner.settings.core_waybill_template_mode.card', 2) : '' }}
                        {{ settings.core_waybill_template_mode == 'detail' ? $tc('ui.scanner.settings.core_waybill_template_mode.detail', 2) : '' }}
                    </span>
                    <!-- <span class="computer hidden"
                        v-if="!is_setting"
                        >
                        . . . . . .
                    </span> -->
                </div>

                <div class="toggle_is_setting_icon"
                    :class="{'show_setting_modes_content':is_setting}">
                    <i class="large icon angle double"
                        :class="{
                            'up': is_setting,
                            'down': !is_setting,
                        }"
                        :style="{
                            color: theme.color.show_setting_icon
                        }"
                        >
                    </i>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        is_processing: Boolean,
        current_scan_action_prototype: Object,
        current_number: String,
        is_inverted: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            input_number: "",
            is_input_mode: false,
            is_loading: false,
        }
    },
    mounted() {
    },
    watch: {

    },
    computed: {
        current_store() {
            return this.$store.state[this.$store.state.current_scope].scanner_module
        },
        theme() {
            return this.current_store.config.theme
        },
        settings() {
            return this.current_store.settings
        },
        is_setting() {
            return this.current_store.is_setting
        },
        current_setting_group() {
            return this.current_store.current_setting_group
        }
    },
    methods: {
        async input_focused() {
            await new Promise(resolve => {
                this.is_input_mode = true
                resolve()
            })
            await new Promise(resolve => {
                this.input_number = this.current_number
                resolve()
            })
            await new Promise(resolve => {
                this.$nextTick(() => {
                    $("#search_input").focus()
                    this.$refs.search_input.focus()
                })

                resolve()
            })
            await this.$bus.$emit('set_input_mode', true)
        },
        async input_blurred() {
            await this.$bus.$emit('set_current_number', this.input_number)
            await new Promise(resolve => {
                this.is_input_mode = false
                this.input_number = ""
                resolve()
            })
            await this.$bus.$emit('set_input_mode', false)
        },
        async input_submit() {
            try {
                await this.input_blurred()
                await this.$bus.$emit('enqueue')
            } catch (e) {
                console.log(e)
            }
        },
        // focus_search_input() {
        //
        //     $("#search_input").focus()
        // },
        // reset_search_input() {
        //     this.current_number = ""
        //     this.$refs.search.value = ""
        //     $('#search_input').val('')
        // },
        // submit() {
        //
            // this.$bus.$emit('set_current_number', this.current_number)
        //     this.reset_search_input()
        // },
        toggle_settings() {
            this.$parent.toggle_settings_div()
        },
    },
    components: {
    },
}
</script>

<style lang="scss" scoped>
.current_setting_group.button {
    & {
        padding: 3px 10px !important;
    }
    .sprite {
        max-width: 40px;
    }
}

#search_input {
    width: 100%;
    height: 46px;
    line-height: 46px;
    padding-left: 40px;
    overflow: hidden;
    white-space: nowrap;
}
@media only screen and (max-width: 767px) {
    .settings.label {
        & {
            font-size: 16px !important;
            display: none;
        }
        &.show_setting_modes_content, .show_setting_modes_content {
            display: inline-block;
        }
        .toggle_is_setting_icon {
            display: none !important;
            position: absolute;
            left: 25%;
            top: 6px;
        }
        .toggle_is_setting_icon.show_setting_modes_content {
            top: auto;
            left: 6px;
            bottom: -8px;
        }
    }
}

.settings.label {
    & {
        position: relative;
        width: 100%;
        margin: 0;
        font-size: 14px;
        text-align: right;
    }
    .settings_content {
        display: inline-block;
    }
    .toggle_is_setting_icon {
        display: inline-block;
    }
}

.settings.label.inverted {
    background-color: var(--inverted-color);
}

.form.inverted {
    & {
        background-color: var(--inverted-color);
    }
    input {
        color: white !important;
    }
    i.search.icon {
        padding-right: 2em !important;
    }
    .button, .button:hover {
        box-shadow: 0 0 0 0px !important;
    }
}

</style>
